/**
 * Why Delete is disabled on a case still holding evidence — the server's own refusal, in its
 * words, so the list and the profile cannot disagree about it. Null when nothing is held.
 */
export function heldEvidenceReason(held: number): string | null {
  if (held <= 0) return null;

  return held === 1
    ? 'This case still holds 1 item of evidence. Transfer or dispose of it first.'
    : `This case still holds ${held} items of evidence. Transfer or dispose of them first.`;
}
